// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pancham: PokeData = {
  "id": 674,
  "name": "pancham",
  "height": 6,
  "weight": 80,
  "base_experience": 70,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "karate-chop",
    "comet-punch",
    "tackle",
    "body-slam",
    "leer",
    "slash",
    "vital-throw",
    "crunch",
    "taunt",
    "arm-thrust",
    "sky-uppercut",
    "low-sweep",
    "entrainment",
    "circle-throw",
    "work-up",
    "parting-shot"
  ],
  "moves": [
    "karate-chop",
    "tackle",
    "body-slam",
    "leer",
    "crunch",
    "close-combat",
    "vacuum-wave",
    "superpower",
    "jump-kick",
    "meteor-assault",
    "rolling-kick",
    "bulk-up",
    "drain-punch"
  ],
  "evolution_chain": {
    "id": 346,
    "item": null,
    "species": [
      {
        "name": "pancham",
        "order": 675,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pangoro",
        "order": 676,
        "types": [
          PokeType.FIGHTING,
          PokeType.DARK
        ],
        "evolves_from_species_id": 674,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61,
    "speed": 43,
    "ability_power": 82
  },
  "stat_changes": [],
  "catch_rate": 220,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
